<template>
  <b-container>
    <h1 align="center" v-if="$mq === 'pc'">
      <span class="mr-4">創造工学センター</span>
      <span>予約申請</span>
      <br />Innovation Plaza Booking form
    </h1>
    <h3 align="center" class="mt-4" v-if="$mq === 'sp'">
      <span class="mr-4">創造工学センター</span>
      <span>予約申請</span>
      <br />Innovation Plaza Booking form
    </h3>
    <b-row class="mb-2 mt-4">
      <b-col sm="10" md="10" lg="10" offset-sm="1" offset-md="1" offset-lg="1">
        <b-alert show variant="info" class="mt-4">
          <div>
            <h3>
              <font-awesome-icon :icon="['fas', 'paper-plane']" class="mr-2" />予約の申請が完了しました。
            </h3>
          </div>
          <div>
            <div class="mt-3 mb-3">
              創造工学センター利用予約の申請をしました。予約はまだ受理されていません。
              <br />後ほど受付の可否についてメールで連絡をいたします。一両日中（土日を除く）に連絡がない場合は、創造工学センターまでお問い合わせください。
            </div>
            <div
              class="mb-4"
            >Your reservation has not been accepted yet. We will review and contact you in 1-2 days. If you do not receive any email, please contact us directory.</div>
            <div>
              【創造工学センター Innovation Plaza, School of Engineering】
              <br />Tel: 022-795-3676
              <br />Email: hatumei@grp.tohoku.ac.jp
            </div>
          </div>
          <div></div>
        </b-alert>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="10" md="10" lg="10" offset-sm="1" offset-md="1" offset-lg="1">
        <button type="button" @click="back" class="btn btn-outline-secondary">
          <font-awesome-icon class="mr-1" :icon="['fas', 'angle-left']" />入力画面に戻る / Back
        </button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {
    back() {
      this.$store.commit("resetForm");

      this.$router.push({
        name: "form",
      });
    }
  },
};
</script>

<style scoped lang="scss">
h1 {
  margin-top: 25px;
  font-size: 36px;
}

div.container {
  font-size: 14px;
}

::placeholder {
  color: #bbbbbb;
  font-size: 0.9em;
}

.outline-secondary {
  border: 1px solid;
  border-color: #748f9d;
}
</style>
